import React, { PureComponent } from "react";
import { NavLink } from "react-router-dom";
// import { Link, NavLink } from "react-router-dom";
import gplayimg from "../../assets/images/footer_playstore_badge.png";
import appleimg from "../../assets/images/footer_appstore_badge.png";
import facebook_default from "../../assets/images/facebook_default.png";
import instagram_default from "../../assets/images/instagram_default.png";
import youtube_default from "../../assets/images/youtube_default.png";
import twitter_default from "../../assets/images/twitter_default.png";
import footer_apple_tv from "../../assets/images/footer_apple_tv.png";
import footer_Roku_logo from "../../assets/images/footer_Roku_logo.png";
import footer_Android_tv_logo from "../../assets/images/footer_Android_tv_logo.png";
import footer_Samsung_logo from "../../assets/images/footer_samsung_smart_tv-1.png";
import footer_LG_logo from "../../assets/images/footer_LG_smart_tv_logo.png";
import footer_amazon_fire_tv from "../../assets/images/footer_amazon_fire_tv.png";
//import firebase from "../../analytics/firebase"
import navImages from "../../utils/navImages";
// import { slugify } from "../../utils/stringSlugify";
import { slugify } from "../../../commonfiles/stringSlugify";
import { withRouter } from "react-router";
//import cleverTap from "../../common/clevertap";
import "./Footer.css";
// import config from "../../utils/config";
import myplexAPI from "../../api/myplexAPI";
import lensEvents from "../../LensAnalytics";
// import firebaseEvents from "../../common/firebaseEvents";
// import Mrecommendations from "./Mobilerecommendations"
// import Portalrecommendations from "./Portalrecommendations"
// import { isMobile } from "react-device-detect";

class footer extends PureComponent {
  list = "";
  constructor(props) {
    super(props);
    this.state = {
      menu: [],
      portalRecommendations: [],
      premimumTabData: '',
    };
    this._isMounted = false;
  }

  componentDidMount() {
    this._isMounted = true;
    this._getMenu();
    this.setPremimumTab();
  }
  componentWillUnmount() {
    this._isMounted = false;
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    if (document.location.pathname === "/") {
      if (
        document.getElementsByClassName("menu-list") &&
        document.getElementsByClassName("menu-list")[0] &&
        document.getElementsByClassName("menu-list")[0].firstElementChild !==
          null
      ) {
        document
          .getElementsByClassName("menu-list")[0]
          .firstElementChild.classList.add("active");
      }
    }
  }
  setPremimumTab(){
    //console.log("premimumTabData ",this.state.premimumTabData);
    this.setState({premimumTabData:{}});
    var data = {};
    if(localStorage.getItem("Logged-in") === undefined || localStorage.getItem("Logged-in") === null){
      data['text'] = 'Activate Your Subscription';
      data['action'] = 'subscribe';
      this.setState({premimumTabData:data});
    }else{
      setTimeout(() => {
        var uPacks = JSON.parse(sessionStorage.getItem("userPackages"));
        if(uPacks && uPacks.features && uPacks.features.enableRenewAction){
          data['text'] = 'Renew Your Subscription';
          data['action'] = 'subscribe';
        }else if(uPacks && uPacks.results && uPacks.results.length > 0){
          data['text'] = 'Subscription Details';
          data['action'] = 'MySubscriptions';
        }else{
          data['text'] = 'Activate Your Subscription';
          data['action'] = 'subscribe';
        }
        this.setState({premimumTabData:data});
      },1000);
    }    
  }
  /* Page Event For CleverTab */
  footerEvent = (pagename) => {
    // if (pagename === 'Home') {
    //     lensEvents.trackhomeview()
    // }
    lensEvents.tabViewed(pagename);
    var tabData = { tab: pagename };
    // firebaseEvents.tabViewed(tabData);
    // firebase.analytics().logEvent('tab viewed', {
    //     'tab':pagename
    // })

    // const clever_tap_data = { "tab name": pagename };
    // cleverTap.pageEvent(clever_tap_data);
  };

  // homeClass = () => {
  //     const page_name_home =
  //         window.location.pathname.split("/")[1] === "home" ? "active" : "";
  //     return `menu_list_link ${page_name_home}`;
  // };

  _getMenu = () => {
    const nav_menu = window.nav_menu;
    this.list = localStorage.getItem("selectedLanguageList");
    this.appLanguage = localStorage.getItem("selectedAppLanguageList");

    if (this.props.menu.length >= 0) {
      this._menuResponse(this.props.menu);
    } else {
      myplexAPI
        .pullPageData(nav_menu, this.list, this.appLanguage)
        .then((response) => {
          this._menuResponse(response.data.results);
        });
    }
  };
  _menuResponse = (response) => {
    if (this._isMounted) {
      this.setState({
        menu: response,
      });
    }
  };
  getFooterNavMenu = () => {
    return this.state.menu.map((m, index) => {
      //  console.log(m)
      let title = m.title;
      if (m.altTitle) {
        title = m.altTitle;
      }
      // console.log(title,m)
      const nav_link = slugify(m.title);
      const nav_images = navImages(m, "hdpi");
      // console.log('navimg',nav_images)
      if (m.layoutType === "menu") {
        return (
          <React.Fragment key={index}>
            {m.appAction === "launchWebPage" ||
            m.appAction === "launchWebPageInChrome" ? (
              <li className="menu_list_item">
                <NavLink
                  to={{ pathname: m.actionUrl }}
                  target={"_blank"}
                  className="menu_list_link"
                  rel="noopener noreferrer"
                  onClick={() => this.footerEvent(m.title)}
                >
                  <i className="mob-icon movies-icon">
                    <img
                      src={nav_images.image}
                      alt={m.title}
                      className="menu_default"
                    />
                    <img
                      src={nav_images.highlighted_image}
                      alt={m.title}
                      className="menu_active"
                    />
                  </i>{" "}
                  <span>{title}</span>
                </NavLink>
              </li>
            ) : (
              <li className="menu_list_item">
                <NavLink
                  to={`/${nav_link}`}
                  className="menu_list_link"
                  onClick={() => this.footerEvent(m.title)}
                >
                  <i className="mob-icon movies-icon">
                    <img
                      src={nav_images.image}
                      alt={m.title}
                      className="menu_default"
                    />
                    <img
                      src={nav_images.highlighted_image}
                      alt={m.title}
                      className="menu_active"
                    />
                  </i>{" "}
                  <span>{title}</span>
                </NavLink>
              </li>
            )}
          </React.Fragment>
        );
      } else {
        return null;
      }
    });
  };
  getSubscriptionpacks = () => {
    var uPacks = sessionStorage.getItem("userPacks")
      ? JSON.parse(sessionStorage.getItem("userPacks"))
      : null;

    return uPacks;
  };

  render() {
    
    return (     
      <footer id="footer" className="footer -footer">
        <div className="wrapper-recommendations">
          <div className="container-fluid">
            <div className="footer_sec">
              <div className="recommendations_list">
                <h4>MANORAMAMAX</h4>
                <ul>
                  <NavLink to="/About-Us">
                    <li>About Us</li>
                  </NavLink>
                  <NavLink to="/Frequently-Asked-Questions">
                    <li>Frequently Asked Questions</li>
                  </NavLink>
                  <NavLink to="/TVChannels">
                    <li>TV Channels</li>
                  </NavLink>
                </ul>
              </div>
            </div>
            {/* {!localStorage.getItem("Logged-in") && ( */}
            {/* {!this.getSubscriptionpacks() &&  */}

            <div className="footer_sec">
              <div className="recommendations_list">
                <h4>PREMIUM</h4>
                {this.state.premimumTabData && 
                <ul>
                  <NavLink to={`/${this.state.premimumTabData.action}`}>
                    <li>{this.state.premimumTabData.text}</li>{" "}
                  </NavLink>
                </ul>
                }
              </div>
            </div>
            {/* } */}
            {/* )} */}

            <div className="footer_sec">
              <div className="recommendations_list">
                <h4>MY VIDEOS & HISTORY</h4>
                <ul>
                  <NavLink to="/Liked-Videos">
                    <li>Liked Videos</li>
                  </NavLink>
                  <NavLink to="/Watch-History">
                    <li>Watch History</li>
                  </NavLink>
                  <NavLink to="/Playlist">
                    <li>Playlist</li>
                  </NavLink>
                </ul>
              </div>
            </div>

            <div className="footer_sec">
              <div className="recommendations_list">
                <h4>TERMS & POLICIES</h4>
                <ul>
                  <NavLink to="/Privacy-Policy">
                    <li>Privacy Policy</li>
                  </NavLink>
                  <NavLink to="/Terms-Of-Use">
                    <li>Terms and Conditions</li>
                  </NavLink>
                 {/* <NavLink to="/Uptandc">
                    <li>UP 3.0 T & C</li>
                  </NavLink>
                  <NavLink to="/ptp-tandc">
                    <li>PTP T & C</li>
                  </NavLink> */}
                  {/* <NavLink to="/Dtandc">
                    <li>Dance Challenge T & C</li>
                  </NavLink>
                  <NavLink to="/save-date-tandc">
                    <li>Save The Date T & C</li>
                  </NavLink> */}
                  <NavLink to="/UP4-RandR">
                    <li>UP4 - R&R</li>
                  </NavLink>
                  {/* <NavLink to="/ranirajacontest">
                    <li>Raani Raaja Contest </li>
                  </NavLink> */}
                  <NavLink to="/rulesandregulations">
                    <li>Rules and Regulations</li>
                  </NavLink>
                  {/* <NavLink to="/dubaicontest">
                    <li>Momo In Dubai- Fly to Dubai contest</li>
                  </NavLink> */}
                  <NavLink to="/eas">
                    <li>Ente Amma Superaa - R & R.</li>
                  </NavLink>
                  {/* <NavLink to="/kbcontest">
                    <li>Kerala Blasters Contest </li>
                  </NavLink> */}
                  {/* <NavLink to="/supershopping">
                    <li>Super Shopping T&C</li>
                  </NavLink> */}
                  <NavLink to="/Terms-Blasters-Football-Contest">
                    <li>Football Contest 2023</li>
                  </NavLink>
                </ul>
              </div>
            </div>

            <div className="footer_sec">
              <div className="recommendations_list">
                <h4>FOR ENQUIRIES & FEEDBACK</h4>
                <ul>
                  <NavLink to="/Contact">
                    <li>Contact Us</li>
                  </NavLink>
                  <a
                    href="https://specials.manoramaonline.com/Mazhavil-Manorama/2021/manorama-max-b2b/index.html"
                    target="_blank"
                  >
                    <li>Advertise With Us</li>{" "}
                  </a>
                  {/* <a href="https://specials.manoramaonline.com/Mazhavil-Manorama/2021/manorama-max-b2b/index.html" target="_blank">
                  <li>UP 3.0 T & C</li> </a> */}
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-content">
          <div className="right-side">
            <div className="col-sm-3">
            <div className="desktop_app_version">
              <div className="copyright">©️ Copyright {new Date().getFullYear()}, MM TV Limited</div>
                <h4>Version 1.1.86.13</h4>
              </div>
            </div>
            <div className="col-sm-2 padding_rmv">
              <div className="footer_social_icons">
              <div className="copyright"> Follow us </div>
                <ul>
                  <li>
                    <a href="https://www.facebook.com/ManoramaMAXOfficial" target="_blank"> <img src={facebook_default} alt="social_icons" rel="noreferrer" /> </a>
                  </li>
                  <li>
                    <a href="https://www.instagram.com/manoramamax/" target="_blank" rel="noreferrer"> <img src={instagram_default} alt="social_icons" rel="noreferrer" /> </a>
                  </li>
                  <li> {" "}
                    <a href="https://www.youtube.com/channel/UCz1ht-a2eKE_s1vMh3OHtIg" target="_blank" rel="noreferrer"> <img src={youtube_default} alt="social_icons" rel="noreferrer" /> </a>
                  </li>
                  <li> {" "}
                    <a href="https://twitter.com/manorama_max" target="_blank"> <img src={twitter_default} alt="social_icons" rel="noreferrer" /> </a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-sm-2 download_app_section padding_rmv">
              <div className="copyright"> Download the App </div>
              <div className="left-side">
                <a target="_blank" href={ "https://play.google.com/store/apps/details?id=com.mmtv.manoramamax.android&hl=en_IN&gl=US" } className="download-app-link"> <img src={gplayimg} alt="appicons" className="googlepay_img img-responsive" /> </a>
                <a target="_blank" href={ "https://apps.apple.com/in/app/manoramamax/id1468454034" } className="download-app-link"> <img src={appleimg} alt="appicons" className="googlepay_img img-responsive" /> </a>
              </div>
            </div>

            <div className="col-sm-5 download_app_section tvs_section padding_rmv">
              <div className="copyright"> Also Available on </div>
                <div className="left-side">
                  <a target="_blank" href={ "https://www.amazon.com/gp/product/B09CGWTW1F" } className="download-app-link firetv_icon"> <img src={footer_amazon_fire_tv} alt="appicons" className="img-responsive" /> </a>
                  <a target="_blank" href={ "https://apps.apple.com/app/manoramaMAX/id1468454034" } className="download-app-link"> <img src={footer_apple_tv} alt="appicons" className="img-responsive" /> </a>
                  <a target="_blank" href={ "https://channelstore.roku.com/en-gb/details/7aaff2f5a05eb9de7365198a02a9cc45/manoramamax" } className="download-app-link"> <img src={footer_Roku_logo} alt="appicons" className="img-responsive" /> </a>
                  <a target="_blank" href={ "https://play.google.com/store/apps/details?id=com.mmtv.manoramamax.android" } className="download-app-link"> <img src={footer_Android_tv_logo} alt="appicons" className="img-responsive" /> </a>      
                  <a target="_blank" href={ "https://www.samsung.com/levant/tvs/smart-tv/smart-hub-and-apps/" } className="download-app-link"> <img src={footer_Samsung_logo} alt="appicons" className="img-responsive" /> </a>
                  <a target="_blank" href={ "https://in.lgappstv.com/main/tvapp/detail?appId=1124611" } className="download-app-link"> <img src={footer_LG_logo} alt="appicons" className="img-responsive" /> </a>
                </div>
            </div>

          </div>
        </div>
        {this.state.menu && (
          <div className="menu_mobile">
            <ul className="menu-list menu-listres">
              {this.state.menu && this.getFooterNavMenu()}
            </ul>
          </div>
        )}
      </footer>
    );
  }
}
export default withRouter(footer);
